import { render, staticRenderFns } from "./privilegeEdit.vue?vue&type=template&id=87a8785c&"
import script from "./privilegeEdit.vue?vue&type=script&lang=js&"
export * from "./privilegeEdit.vue?vue&type=script&lang=js&"
import style0 from "./privilegeEdit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports